import { render, staticRenderFns } from "./ProjectPostingItemDuplicateModal.vue?vue&type=template&id=393b7da4"
import script from "./ProjectPostingItemDuplicateModal.vue?vue&type=script&lang=js"
export * from "./ProjectPostingItemDuplicateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports